export const TRAINING_RECORD_ROOT_URL = '/training_record';
export const TRAINING_RECORDS_SEARCH_URL = '/training_record/search';
